const base64UrlEncode = (bytes: Uint8Array): string => {
	let binary = '';
	bytes.forEach((byte) => {
		binary += String.fromCharCode(byte);
	});
	return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export const createCodeVerifier = (): string => {
	const bytes = new Uint8Array(32);
	window.crypto.getRandomValues(bytes);
	return base64UrlEncode(bytes);
};

export const createCodeChallenge = async (verifier: string): Promise<string> => {
	const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
	return base64UrlEncode(new Uint8Array(digest));
};
